import ValidateUserGroupCellRest from '../../components/ValidateUserGroupCellRest'

const WebsitePagePage = (routingInfo) => {
  const { user } = routingInfo;

  return <ValidateUserGroupCellRest routingInfo={routingInfo} id={user?.id} user={user} />
}

export default WebsitePagePage
